import { useState } from 'react';
import styled from 'styled-components';
import { CredusText, color } from 'ui';
import { useNavigate } from 'react-router';

import CandidateReUpLoad from './CandidateReUpLoad';
import ReviewUpload from './ReviewUpload';
import ExamCategory from './ExamCategory';

import { CandidateProvider } from '../../../../contexts/CandidateContext';

export type TitleDivProps = {
  active?: boolean;
};

const CandidateUpload = () => {
  const [reviewUpload, setReviewUpload] = useState(false);
  const [candidateReUpload, setCandidateReUpload] = useState(false);
  const [showImportCandidate, setShowImportCandidate] = useState(false);

  const navigate = useNavigate();

  const title = [
    {
      name: 'Candidates',
      active: true,
      route: '/test-management/candidate-upload',
    },
    { name: 'Test', active: false, route: '/test-management/test-upload' },
    { name: 'Report', active: false, route: '/test-management/report' },
  ];
  return (
    <CandidateProvider>
      <Container>
        {candidateReUpload && (
          <CandidateReUpLoad
            setCandidateReUpload={setCandidateReUpload}
            setReviewUpload={setReviewUpload}
            setShowImportCandidate={setShowImportCandidate}
          />
        )}
        {reviewUpload && <ReviewUpload setReviewUpload={setReviewUpload} />}
        {!candidateReUpload && !reviewUpload && (
          <>
            <TabDiv>
              <Div>
                {title.map((el) => (
                  <TitleDiv
                    key={el.name}
                    active={el.active}
                    onClick={() => navigate(el.route)}
                  >
                    <CredusText
                      size="md"
                      weight="bold"
                      color={el.active ? color.primary : ''}
                    >
                      {el?.name}
                    </CredusText>
                  </TitleDiv>
                ))}
              </Div>
            </TabDiv>

            <ExamCategory
              setCandidateReUpload={setCandidateReUpload}
              showImportCandidate={showImportCandidate}
              setShowImportCandidate={setShowImportCandidate}
            />
          </>
        )}
      </Container>
    </CandidateProvider>
  );
};

export default CandidateUpload;

const Container = styled.div``;
const TabDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 7rem;
`;

const Div = styled.div`
  display: flex;
  gap: 2rem;
`;

const TitleDiv = styled.div<TitleDivProps>`
  padding: 2px;
  padding-bottom: 1rem;
  cursor: pointer;
  border-bottom: ${({ active }) =>
    active ? '3px solid' + color.primary : 'none'};
`;
